import React, { useState, useEffect, useRef } from "react";

import { Button, Form, Row, Col } from "react-bootstrap";

import Modal from "react-bootstrap/Modal";
import { daysFactor, eskalationsLevel } from "./globalVariables";
import { sortArrayOfObjects } from "./pureFunctions";
import { goToOOAddress } from "./networkFunctions";

export default function ProjektstatusAkquiseKunden({ data, heading, userObjects }) {
   const [show, setShow] = useState(false);
   const [enhancedData, setEnhancedData] = useState();
   const [sortedItems, setSortedItems] = useState([]);
   const [maxCounter, setMaxCounter] = useState(1);

   useEffect(() => {
      let newEnhancedData = structuredClone(data)
         .filter((item) => item.notifications)
         .map((item) => {
            let maxDays = Object.values(item.notifications)
               .flat()
               .reduce(
                  (oldItem, item) =>
                     oldItem > new Date(item.ind_2582_Feld_adressen73)
                        ? new Date(item.ind_2582_Feld_adressen73)
                        : oldItem,
                  new Date(),
               );

            return {
               ...item,
               count: calcNotifications(item),
               maxDays: Math.floor((new Date() - maxDays) / daysFactor),
            };
         });

      setEnhancedData(sortArrayOfObjects(newEnhancedData, "count", -1));

      let newMax = 0;
      data.forEach((userItem) => {
         newMax = Math.max(newMax, calcNotifications(userItem));
      });
      setMaxCounter(newMax);
   }, []);

   function calcNotifications(userData) {
      if (userData?.notifications) return Object.values(userData.notifications).flat().length;
      else return 0;
   }

   return (
      <div className="projektstatus-l2">
         {heading && <h2>{heading}</h2>}
         {enhancedData?.map((userData) => {
            return (
               <React.Fragment key={"sK_" + userData.username}>
                  <div
                     className={"projektstatus-summe"}
                     style={{
                        backgroundColor: "rgba(200,0,0," + userData.count / maxCounter + ")",
                        color: "white",
                     }}
                     onClick={() => setShow(userData)}
                  >
                     <span>{userData.username}</span>
                     <span className="ms-2">
                        {userData.maxDays && (
                           <small
                              style={{
                                 // backgroundColor: "#fff",
                                 backgroundColor: `color-mix(in srgb, #f00 ${Math.min((100 * userData.maxDays) / 21, 100)}%, #fff3)`,
                                 color: "#fff",
                                 padding: "2px 8px",
                                 borderRadius: "6px",
                                 marginRight: "8px",
                              }}
                           >
                              {userData.maxDays}
                           </small>
                        )}{" "}
                        {userData.count}
                     </span>
                  </div>
                  {show && (
                     <Modal show={show} size="lg" onHide={() => setShow(false)}>
                        <Modal.Header closeButton>
                           <Modal.Title>
                              <div className="projekt-statusheading">
                                 <span className="ms-2">{show.count}</span>
                                 <span className="ms-2">von {show.username}</span>
                              </div>
                           </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                           <div className="projektstatus-table">
                              {Object.keys(show.notifications).map((notKey, index) => {
                                 return (
                                    <React.Fragment key={"_" + notKey}>
                                       <h4 className={index != 0 ? "mt-4" : ""}>{notKey}</h4>
                                       {show.notifications?.[notKey]?.map((notData) => {
                                          let color = "#089";

                                          return (
                                             <button
                                                style={{
                                                   width: "100%",
                                                   padding: "8px 0px",
                                                   backgroundColor: color
                                                      ? `color-mix(in srgb, ${color} 80%, #000)`
                                                      : "#522",
                                                }}
                                                key={"aK_" + notData.id}
                                                target="_blank"
                                                onClick={() => {
                                                   goToOOAddress(notData.id);
                                                }}
                                             >
                                                <span className="text-start">
                                                   {" "}
                                                   {notData.KdNr} | {notData.Vorname} {notData.Name}
                                                </span>
                                                {
                                                   <small
                                                      style={{
                                                         marginLeft: "14px",
                                                         backgroundColor: `color-mix(in srgb, #f00 ${0}%, #0009)`,
                                                         padding: "2px 10px",
                                                         borderRadius: "4px",
                                                         position: "absolute",
                                                         right: "20px",
                                                         width: "160px",
                                                         // outline: "solid 1px #f00"
                                                         // boxShadow: "inset 0 0 10px #fff3"
                                                      }}
                                                   >
                                                      {" "}
                                                      seit{" "}
                                                      {new Date(notData.ind_2582_Feld_adressen73).toLocaleDateString()}
                                                   </small>
                                                }
                                             </button>
                                          );
                                       })}
                                    </React.Fragment>
                                 );
                              })}
                           </div>
                        </Modal.Body>
                        <Modal.Footer>
                           <Button variant="secondary" onClick={() => setShow(false)}>
                              Schliessen
                           </Button>
                        </Modal.Footer>
                     </Modal>
                  )}
               </React.Fragment>
            );
         })}
      </div>
   );
}
